import DroppedPinIcon from "../components/DroppedPinIcon";
import FreeIcon from "../components/FreeIcon";
import Logo from "../components/Logo";
import ShieldElectricIcon from "../components/ShieldElectricIcon";
import Spec from "../components/Spec";
import EventCountdown from "../components/EventCountdown";
import EventDate from "../components/EventDate";
import Hero from "../components/Hero";
import Organizers from "../components/Organizers";
import ImageCarousel from "../components/ImageCarousel";
import VideoSection from "../sections/VideoSection";
import Sponsors from "../components/Sponsors";
import ButtonLink from "../components/ButtonLink";
import eventFormatPhoto from "../assets/spiderman.jpeg";
import post_logo from "../assets/spcs_logo.svg"
import video_image from "../assets/hilton_geneva.jpg"
import tenable_logo from "../assets/sponsors/tenable-logo.png";
import vectra_logo from "../assets/sponsors/vectra-logo.png";
import harfanglab_logo from "../assets/sponsors/harfanglab.png"
import elastic_logo from "../assets/sponsors/elastic-logo-reverse.svg";
import airlock_logo from "../assets/sponsors/airlock-logo.png";
import ywh_logo from "../assets/sponsors/YWH_logo.png"
import splunk_logo from "../assets/sponsors/splunk.png";
//import c2sec_logo from "../assets/sponsors/c2sec-logo.png";
//import cribl_logo from "../assets/sponsors/cribl-logo.png";
//import karspersky_logo from "../assets/sponsors/karsperky-logo.png";
//import knowbe4_logo from "../assets/sponsors/knowbe4.png";
//import menlo_logo from "../assets/sponsors/menlo-security-logo.png";
//import one_identity_logo from "../assets/sponsors/one-identity.png";
//import microsoft_logo from "../assets/microsoft_logo.png";
//
import PlanningSection from "../sections/PlanningSection";
import Agenda from "../components/Agenda";
import ThankYouNote from "../components/ThankYouNote";

//import speaker_sander_hofman from "../assets/speakers/Hofman_Sander.jpg";
import speaker_bob_lord from "../assets/speakers/Lord headshot low res.jpg";
import speaker_guillaume_vassault from "../assets/speakers/guillaume-vassault-houliere.jpg";
import speaker_emmanuel_schmid from "../assets/speakers/Schmid_Emmanuel.jpg";
import speaker_nicolas_aunay from "../assets/speakers/Aunay_Nicolas.jpg"
import speaker_lena_jakubowicz from "../assets/speakers/Lena_Jakubowicz.png";

import SpeakerSection from "../sections/SpeakerSection";
/*
import Sponsors from "../components/Sponsors";
import infomaniak from "../assets/infomaniak.png";
import pwc_outlined_logo from "../assets/pwc_outlined_logo.png";
import hkta_logo from "../assets/hkta_logo.png";
import sentinel_one from "../assets/sponsors/SentinelOne_Logo_white-purple.png";
import fortinet_logo from "../assets/sponsors/fortinet-logo.png";
import cyberreason from "../assets/sponsors/cyberreason-logo.png";
import threatray from "../assets/sponsors/threatray-logo.png";

import speaker_thomas_cueni from "../assets/speakers/thomas-cueni.jpg";
import speaker_rene_bodmer from "../assets/speakers/rene-bodmer.png";
import speaker_luca_bertolotto_cipriani from "../assets/speakers/luca-bertolotto.png";
import speaker_fabian_gentinetta from "../assets/speakers/fabian_gentinetta.jpeg";
import speaker_martin_de_jongh from "../assets/speakers/MartinDJ_SentinelOne.png";
import speaker_eric_de_bressing from "../assets/speakers/eric-de-bressing.jpeg";
import speaker_patrick_buchholz from "../assets/speakers/patrick-buchholz.jpg";
import speaker_marcel_zumbuehl from "../assets/speakers/marcel-zumbuehl.png";
import speaker_detlev_narr from "../assets/speakers/detlev-narr.png";
*/
import speaker_unknown from "../assets/speakers/unknown_person.jpg";


const eventDate: Date = new Date(2026, 5, 9, 12, 45); // 9 june 2026

export default function GenevEventTab() {
  return (
    <div className="container">
      <ThankYouNote />
      <section>
        <div style={styles.logoContainer}>
          <Logo width="auto" height="102px" />
        </div>
        <EventDate date={eventDate} />
        <Hero
          title="Genev’Hack"
          subtitle="Taking cybersecurity seriously, but not ourselves<br><br>A keynote presentation with inspiring insights from the perspective of a well-known CISO, exciting input presentations, and good networking opportunities await you. Aimed at Cybersecurity Experts, IT enthusiasts and Students with a Networking Apero in the evening"
          titleStyle={styles.title}
          subtitleStyle={styles.subtitle}
        />
        <div className="specs-container">
          <Spec icon={<DroppedPinIcon />} title="Hilton Hotel Geneva" url="https://maps.app.goo.gl/pfoiFfXcWXow3agE7"/>
          <Spec icon={<FreeIcon />} title="100% Free" />
          <Spec icon={<ShieldElectricIcon />} title="100% cybersecurity" />
        </div>
        <EventCountdown date={eventDate} />
      </section>
      <section>
        <ButtonLink
          href="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594583/"
          newTab={true}
          style={{ maxWidth: "161px" }}
        >
          Register
        </ButtonLink>
      </section>
      {/*
      <section>
        <AboutTheEvent mapUrl="./palexpo-plan.pdf"/>
      </section>
      */}
      {/*
      <section>
        <EventFormat imageSrc={eventFormatPhoto}/>
      </section>
      */}
      {
      <section>
        <Agenda
          headers={['', '']}
          agenda={[
            { time: "12:45 - 13:15", description1: "Registration and Welcome Coffee" },
            { time: "13:15 - 13:30", description1: "Opening Ceremony" },
            { time: "13:30 - 14:00", description1: "Hacklore and Secure by Design: How Stories Affect Our Safety [Bob Lord, former CISO of Yahoo and Founder of Hacklore.org]" },
            { time: "14:00 - 14:30", description1: "Threat Landscape Report by Swiss Post Cybersecurity" },
            { time: "14:30 - 15:00", description1: "Defending against legitimate tools. How to protect yourself when attackers reuse your own tools? [HarfangLab]" },
            { time: "15:00 - 15:25", description1: "Networking Break" },
            { time: "15:25 - 17:15", description1: "<b>Technical Presentations</b><ul><li>AI in the Hackers' loop<br>[Guillaume Vassault-Houlière, CEO & co-founder, YesWeHack]</li><li>Every public OT breach is a free lesson: Are you taking notes?<br>[Emmanuel Schmid, Senior Security Engineer, Swiss Post Cybersecurity]</li><li>Physical Intrusion: Field Notes from the Other Side of the Door<br>[Nicolas Aunay, Senior Offensive Security Engineer and Nicolas Boust, Offensive Security Engineer, Swiss Post Cybersecurity]</li><li>After the login — why attackers live between your tools and what your SOC can do about it<br>[Vectra AI]</li>" },
            { time: "17:30", description1: "Apero and Networking" },
            { time: "18:00 - 20:00", description1: "Capture-the-Flag (CTF) with Vetra AI; Detecting Hybrid Attacks with Respond UX" },
          ]
          }
        ></Agenda>
      </section>
      }
      {
      <section>
      <PlanningSection
          title=""
          subtitle=""
          displayGrid=""
          planning={[
            {
              time: "18:00 - 20:00",
              title: "Capture-the-Flag (CTF): Detecting Hybrid Attacks with Respond UX",
              description: "Join this 90-minute hands-on Blue Team challenge and discover how hybrid attacks can be detected across network and cloud environments using Vectra AI. Designed for beginner to intermediate participants, this session introduces the fundamentals of the Vectra platform and Respond UX, with a focus on alert triage, investigation workflows, and practical threat detection skills in a realistic SOC-style scenario. Trophies will be awarded to the top 3 teams.<br><br><b>Target audience:</b> Security analysts, SOC engineers, Security Enthusiasts and MSSP operations staff beginning their journey with the Vectra AI ecosystem.",
              index: 0,
              registerBtnText: 'Register now',
              registerUrl: 'https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594580',
              logo: vectra_logo
            }
          ]}
        />
      </section>
      }
      {/*
      <section>
        {
        <PlanningSection
          title="Details"
          subtitle=""
          displayGrid="grid"
          planning={[
            {
              time: "13:00",
              title: "",
              description: "<h1>Registration & Welcome coffee</h1>",
              index: 0,
            },
            {
              time: "",
              title: "Network meets Identity: Modern detection and response for the hybrid world<br><small>Vectra - Fabian Gentinetta / Christian Borst</small>",
              description: "The modern network has changed. We went remote, and into the cloud. The cloud grew, and became more complex. Today, Active Directory and Entra ID stand at the core of most networks. IT and OT are converging, into one giant attack surface. In this talk, we offer strategic perspectives on how to navigate and secure this new reality.",
              index: 1,
            },
            {
              time: "",
              title: "Post Login: Stopping Lateral Movement with Privileged Access Analytics<br><small>Vectra - Aurélien Hess / Christoph Riese / Fabian Gentinetta</small>",
              description: "Attackers know the complexities of managing account permissions across network, cloud and SaaS apps leave gaps for them to abuse. Privileged accounts are routinely used to steal sensitive information and disrupt operations, without ever needing to run an exploit. Some SOC teams focus on monitoring failed login attempts and unusual user behavior, and lean on multi-factor authentication (MFA) to reduce risk. The truth is, those security measures are just one part of the ATO protection equation. You need a proven way to see and stop account takeover attacks in real time.",
              index: 2,
            },
            {
              time: "",
              title: "Searching or finding? In front of or behind your line(s) of defense?<br><small>Kaspersky - Detlev Narr</small>",
              description: "You probably already have the tools! What rules to write? What data to correlate? How to stay up to date? The presentor answers these questions and more, and showcases how you can use Threat Intelligence to improve your organization's security.",
              index: 3,
            },
            {
              time: "",
              title: "Human Risk Management based on AI<br><small>KnowBe4 - Paul Nkengue </small>",
              description: "This presentation focuses on what is probably the most unpredictable part of the IT security equation: people. From phishing attacks and poor password practices to careless handling of sensitive data, learn how to tackle these issues efficiently and effectively.",
              index: 4,
            },
            {
              time: "",
              title: "Goodbye Purple Team, Hello Purple Bots<br><small>Swiss Post Cybersecurity - Patrick Mkhael & Ralph El-Khoury</small>",
              description: "This talk unveils a fully automated, AI-driven purple teaming framework that simulates real-world APT attacks, evaluates detection capabilities, and enhances security defense, all in real-time.",
              index: 5,
            },
            {
              time: "",
              title: "Tenable One: Holistic Exposure Management<br><small>Tenable - Thomas Cueni</small>",
              description: "Threat actors do not adhere to silos in the security field. They look for vulnerabilities of all kinds to exploit and move laterally through the environment. But the tools organizations rely on to secure their attack surface often focus only on individual technologies - cloud, identities, IT, OT, IoT, applications - and generate an enormous amount of unnecessary data. What's missing is a cross-functional view of the relationships between assets, identities and risks that enable attacks, and more importantly, the impact on the organization, whether in terms of revenue, data sovereignty, compliance or other critical metrics.<br>The Tenable One exposure management platform unifies visibility, insights and actions across the entire attack surface. ",
              index: 6,
            },
            {
              time: "",
              title: "Capabilities of Modern Security Platforms<br><small>Splunk - Jürg Fischer / Eric De Bressing</small>",
              description: "The right tool for the right job: old and new critical capabilities for SecOps & Enterprise Resilience",
              index: 7,
            },
            {
              time: "",
              title: "Beyond Compliance: Building Resilient & Secure Third-Party Ecosystems<br><small>C2SEC - Renato Martignoni</small>",
              description: "Increasing third-party cyberattacks highlight why vendor risk must go beyond compliance and become part of everyday security operations. This session explores how organizations can leverage evolving regulations like DORA to move beyond one-time compliance toward building continuously secure third-party ecosystems.",
              index: 8,
            },
            {
              time: "",
              title: "A Modern Approach to Telemetry Data Management<br><small>Cribl - Sven Eichfuss / Christoph Dittmann</small>",
              description: "The tidal wave of data is rising, asking for a modern approach to managing and utilizing telemetry data. Cribl will highlight the value of providing teams with ownership over their data while ensuring overall governance and security.",
              index: 9,
            },
            {
              time: "",
              title: "Shadows in the Cloud: Unmasking Advanced Evasion Techniques <br><small>Menlo - Tom McVey / Brett Raybould</small>",
              description: "This session exposes the mechanics behind today's most sophisticated cloud-based attacks. Through live demonstrations of credential phishing and HTML smuggling techniques, Menlo Security's experts will dissect how threat actors bypass traditional security controls. Participants will witness firsthand how these attacks unfold and learn the architectural approaches needed to defend against browser based threats",
              index: 10,
            },
            {
              time: "",
              title: "Threat modeling and it's importance<br><small>Post  - Heinz Wittig </small>",
              description: "In the past two years, the Swiss Post team has embarked on the complex journey of implementing Threat Modeling, akin to the journeys of the companions through Middle-earth. Along the way, they faced challenges reminiscent of the trials of Moria and the watchful eye of Sauron, as well as threats and resistance. Through perseverance and collaboration, they overcame these obstacles and learned more about potential security risks and their early identification. Join them on their adventure and discover the key lessons and strategies that have led them to success in the ever-evolving world of cybersecurity",
              index: 11,
            },
            {
              time: "",
              title: "One Identity Fabric - foundation for modern identity management<br><small>OneIdentity - Reto Bachman / Eric Parietti</small>",
              description: "Presentation of an ecosystem that enables organizations to implement authentication and authorization for all identities (including general users, privileged accounts and third parties) across the entire infrastructure.",
              index: 12,
            },
            {
              time: "",
              title: "Tabletop Exercises: Because real Chaos has no pause button<br><small>Swiss Post Cybersecurity - Greg Divorne </small>",
              description: "We’ll break down the real value of cybersecurity table-tops — no simulations, just sharp insights, common pitfalls, and how to make chaos a little more manageable.",
              index: 13,
            },
            {
              time: "",
              title: "OT Security: Tips & Tricks<br><small>Swiss Post Cybersecurity - Christian Fichera & Raphael Ruf</small>",
              description: "OT and IT are different in many ways, and cybersecurity is certainly one of them. Priorities, vulnerabilities and how to remediate them are all key differences between these two worlds.<br>As a pentester, the way you approach assessing IT and OT environments needs to be different too, and the specific knowledge a tester has in the OT world can make the difference between a successful test and a broken OT device.<br>A demo taken from real life pentesting experience will also show how easy it can be to compromise OT environments.",
              index: 14,
            },
            {
              time: "",
              title: "Threat Hunting Basics<br><small>Swiss Post Cybersecurity - Antony Ancelin</small>",
              description: "From Intel to Hunts. Threat hunting isn’t new but this session is a practical reminder of the basics. Learn how to use threat intelligence to build hunting hypotheses, assess visibility gaps, and take action when signs of compromise are foundWe will also discuss common challenges MSSPs face when handling CTI and provide a practical example of using CTI use case.",
              index: 15,
            },
            {
              time: "17:00",
              title: "",
              description: "<h1>Apero and Networking</h1>",
              index: 16,
            }
          ]}
        />
        }

      </section>
      */}
      {<section>
        {
        <SpeakerSection
          title=""
          subtitle="Attendees will leave feeling more connected to a community of builders and to the future of the evolving world of cybersecurity"
          speakers={[
            {
              firstName: "Bob",
              lastName: "Lord",
              role: "Former CISO of Yahoo and Founder of Hacklore.org",
              title: 
                "Hacklore and Secure by Design: How Stories Affect Our Safety",
              description:
                "Cybersecurity has a story problem. Juice jacking warnings. QR code panic. Public Wi-Fi paranoia. These urban legends spread through headlines and corporate training decks because the stories are compelling — and compelling stories shape not just what people believe, but who they believe is responsible for staying safe. The Hacklore project examines how false, exaggerated, and outdated security guidance spreads, why it endures, and what it costs us when we place the burden of security on individual behavior instead of the systems that produce harm. But stories don't just spread bad advice — they assign blame. If we want software that is Secure by Design, with security baked in rather than bolted on, we need to start telling stories that point in a different direction: toward the builders, not the users. Hacklore and Secure by Design are two sides of the same story. It's time we changed the ending.",
              image:
              speaker_bob_lord,
            },
            {
              firstName: "Léna",
              lastName: "Jakubowicz",
              role: "Head of Solution Engineers, HarfangLab",
              title: "Defending against legitimate tools. How to protect yourself when attackers reuse your own tools?",
              description:
                "8 out of 10 attacks no longer use malware. Attackers, whether ransomware operators or state-sponsored groups, now leverage your own administration tools to conduct their operations. PowerShell to execute code in memory, PsExec to deploy ransomware across an entire fleet... No malicious file, no signature to detect: this is the principle of Living-off-the-Land. It was recently discovered that the Chinese group Volt Typhoon had maintained stealthy access for several years within American critical infrastructure, using nothing but native system tools. On the ransomware side, groups like BlackCat or Black Basta systematically rely on these same techniques to bypass existing security solutions. How do you detect what appears legitimate but is actually malicious? Which signals should you prioritize monitoring?  This presentation aims to shed light on the mechanisms behind Living-off-the-Land and fileless attacks through concrete cases, and to propose best practices to regain the upper hand.",
              image:
                speaker_lena_jakubowicz,
            },
            {
              firstName: "Guillaume",
              lastName: "Vassault-Houlière",
              role: "CEO & co-founder, YesWeHack",
              title: 
                "AI in the Hackers' loop",
              description:
                "In the era of AI and a booming cybersecurity market, we are witnessing a massive marketing blitz promising that artificial intelligence will revolutionize cyber defense and more particularly, vulnerability research. However, beyond the commercial rhetoric that has yet to be fully challenged, the impact of AI on the systems we defend is very real: vulnerabilities are being exploited faster and on an unprecedented scale. Cyber threats are becoming increasingly industrialized, and advanced technical skills are no longer a prerequisite for launching an automated attack against a company. But is this a true revolution? The constant arms race between attackers and defenders is what has shaped the evolution of cybersecurity from the beginning. In hacking, as in engineering, tooling and automation are indispensable steps in the search for vulnerabilities. While the arsenal is expanding, the best hackers will remain, as they always have been, master craftsmen, but equipped with tools they have mastered to perfection. Hacking is an art. The hacker is the artisan, capable of creating, building, reimagining, and diverting with the tools of their time. Human expertise remains essential to contextualize attacks and, above all, to innovate in a field where creativity prevails over simple execution.",
              image:
              speaker_guillaume_vassault,
            },
            {
              firstName: "Emmanuel",
              lastName: "Schmid",
              role: "Senior Security Engineer, Swiss Post Cybersecurity",
              title: 
                "Every public OT breach is a free lesson: Are you taking notes?",
              description:
                "Operational Technology (OT) security is often framed around ultra-sophisticated adversaries. However, analysis of recent public incidents reveals a recurring reality: a lack of basic security controls. When visibility is limited, we are giving attackers what they need most: time. This session breaks down public OT breaches into actionable threat intelligence by asking a simple questions : what would have caught this, and at what stage? The answers are unglamorous: visibility gaps to close and detection opportunities you can act on today. Public incidents are a gold mine. If we don’t leverage them, we miss a key opportunity to sharpen and adapt OT cybersecurity monitoring strategies.",
              image:
              speaker_emmanuel_schmid,
            },
            {
              firstName: "Nicolas",
              lastName: "Aunay",
              role: "Senior Offensive Security Engineer, Swiss Post Cybersecurity",
              title: 
                "Physical Intrusion: Field Notes from the Other Side of the Door",
              description:
                "This talk presents concrete feedback from physical pentest missions conducted across varied environments: datacenters, corporate headquarters, industrial sites, and sensitive facilities. Through anonymized real-world cases, we explore the most effective intrusion vectors, systemic failures in security controls, and the social psychology that makes these attacks possible.",
              image:
              speaker_nicolas_aunay,
            },
            {
              firstName: "",
              lastName: "",
              role: "Vectra AI",
              title: 
                "After the login — why attackers live between your tools and what your SOC can do about it",
              description:
                "Most security investments focus on keeping attackers out. But 80% of modern breaches begin with compromised credentials — attackers log in, they do not break in. Once inside, they move laterally using legitimate protocols, escalate privileges through cloud control planes, and operate in the gaps between EDR, SIEM, and identity tools that were never designed to see each other's blind spots. In this session, our strategic partner Vectra AI shares real-world observations from monitored environments on how post-access attacks unfold, where traditional detection falls short, and how advanced detection — correlated behavioural analysis across network, identity, and cloud — closes those gaps. You will walk away with a practical framework for evaluating whether your current SOC coverage matches today's threat landscape, and what to ask your provider if it does not.",
              image:
              speaker_unknown,
            }
            /*
            {
              firstName: "Gilles",
              lastName: "Peter",
              title: "Territory Manager Suisse",
              description:
                "",
              image:
                speaker_unknown,
            }
            */
          ]}
        />
        }
      </section>}
      {
      <Sponsors
        style={{ marginTop: "120px" }}
        logos={[
          [harfanglab_logo],
          [elastic_logo, tenable_logo, vectra_logo],
          [airlock_logo, ywh_logo, splunk_logo]
        ]}
      />
      }
      <section>
        <Organizers
          organizers={[
            { src: post_logo, name: "Swiss Post Cybersecurity" }
          ]}
        />
      </section>
{       <ImageCarousel
        images={[
          eventFormatPhoto,
          "/img/21efdf712cf79fbd148856011f58bc6e.jpeg",
          "/img/2205cda10dfebc8d1ca3a5bbf2f8515e.jpeg",
          "/img/a7dc9838a6d79336be95edcbb10943c9.jpeg",
          "/img/c67f653b353385bcc7e424359aa6b3e8.jpeg",
          "/img/d6b45f79c4a62172598e9531d0587924.jpeg"
        ]}
        borderRadius="20px"
        height="284px"
        width="90%"
      /> }
      <section>
        <VideoSection
          video="https://maps.app.goo.gl/pfoiFfXcWXow3agE7"
          title="Genev'Hack"
          registerUrl="https://infomaniak.events/en-ch/shop/hack-event-2026-7JXWQVQSMG/event/1594583"
          image={video_image}
        />
      </section>
    </div>
  );
}

const styles = {
  logoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  title: {
    background: "linear-gradient(90deg, #FFF 27.78%, #E1E1E1 100%)",
    backgroundClip: "text",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontFamily: "Poppins",
    fontSize: `${window.outerWidth < 768 ? "12vw" : "5vw"}`,
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
    margin: 0,
  },
  subtitle: {
    fontFamily: "Arvo",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
    marginTop: "-18px",
    textAlign: "center" as "center",
  },
};
